import { render, staticRenderFns } from "./ContractSendModal.vue?vue&type=template&id=645a8616&scoped=true"
import script from "./ContractSendModal.vue?vue&type=script&lang=js"
export * from "./ContractSendModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645a8616",
  null
  
)

export default component.exports